export default "__VITE_ASSET__16df09b0__$_?component__"